import { isParkPlusWebView } from "core-lib/utils/source";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAuth } from "../../hooks/useAuth";
import { useNativeAuth } from "../../hooks/useNativeAuth";

export function RequireAuthWithToken(ComposedComponent) {
  function TokenOutput({
    query,
  }: {
    query: { [key: string]: string };
    pathname: string;
    asPath: string;
  }) {
    const isAuthenticated: boolean = useSelector(
      (state) => state.auth.isAuthenticated
    );
    const isStateRestored: boolean = useSelector(
      (state) => state.setting.isStateRestored
    );

    const [readyForRender, setReadyForRender] = React.useState<boolean>(
      !!isAuthenticated
    );

    const { setAuthData, redirectToLogin } = useAuth();

    const { login: nativeLogin } = useNativeAuth();

    function checkAuth() {
      if (query?.auth_token || query?.refresh_token) {
        const reqData = {
          accessToken: query?.auth_token,
          refreshToken: query?.refresh_token,
        };
        setAuthData(reqData);
      } else if (!isAuthenticated) {
        if (isParkPlusWebView()) {
          setTimeout(() => {
            nativeLogin();
          }, 1000);
        } else {
          redirectToLogin();
        }
      }
    }

    useEffect(() => {
      if (isStateRestored) checkAuth();
    }, [isStateRestored]);

    useEffect(() => {
      if (isAuthenticated) setReadyForRender(true);
    }, [isAuthenticated]);

    if (!readyForRender) return null;

    const props = arguments[0] ?? {};
    if (readyForRender) return <ComposedComponent {...props} />;
  }

  return TokenOutput;
}
